import { capitalizeFirstLetter } from '../utils'



const CoursesPop = ({ error, handleOpenModal }) => { 
    const { header, subHeader, body, subBody, flag } = error  
console.log("flag",flag)
    return (
        <div className="modal_body">
            <div className="attached_courses">
                <h2>{header} <span className="mt_2" style={{ textTransform: 'lowercase' }}>{subHeader?.toLowerCase()}</span></h2>
                {
                    <p style={{ textAlign: 'center' }}><span className="mt_2">{capitalizeFirstLetter(body || '')}</span><span style={{ textTransform: 'capitalize' }}>{subBody}</span></p>
                }
                <form onSubmit={e => e.preventDefault()}>
                    <input type='text' style={{ display: 'none' }} autoFocus />
                    <input onClick={() => handleOpenModal(flag)} type="submit" autoFocus className="btn btn_gray d_block mx_auto" value="ok" />
                </form>
            </div>
        </div>
    )
};

export default CoursesPop;